import { useCallback, useEffect, useState } from "react";

import client from "../client";
import handleApiError from "../../hooks/handleApiError";

export default function useFetchSchoolBillingDetails(schoolId) {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(false);

  const request = useCallback(async (id) => {
    try {
      setLoading(true);
      const response = await client.get(`/school/${id}/billing`);

      setData(response.data?.data);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      handleApiError(error);
    }
  }, []);

  useEffect(() => {
    if (schoolId) request(schoolId);
  }, [request, schoolId]);

  return { request, loading, data };
}
